<template>
  <div class="SForm">
    <el-form
      ref="dataForm"
      :inline="inline"
      :model="dataForm"
      :rules="rules"
      :label-position="labelPosition"
      :label-width="labelWidth"
    >
      <el-form-item
        v-for="(item, index) in fields"
        v-show="!item.isHide"
        :key="index"
        :label="item.label"
        :prop="item.prop"
        :rules="item.rules"
        :style="formStyle"
      >
        <el-select
          v-if="item.type === 'select'"
          v-model="dataForm[item.prop]"
          filterable
          :placeholder="item.placeholder"
        >
          <el-option
            v-for="(option, index) in item.data"
            :key="index"
            :label="option.label"
            :value="option.value"
          />
        </el-select>

        <el-radio-group
          v-else-if="item.type === 'radio'"
          v-model="dataForm[item.prop]"
        >
          <el-radio
            v-for="(option, index) in item.data"
            :key="index"
            :label="option.value"
          >{{ option.label }}</el-radio>
        </el-radio-group>

        <el-switch
          v-else-if="item.type === 'switch'"
          v-model="dataForm[item.prop]"
          :placeholder="item.placeholder"
        />

        <el-date-picker
          v-else-if="item.type === 'date'"
          v-model="dataForm[item.prop]"
          :type="item.option.type"
          :placeholder="item.placeholder"
        />

        <el-transfer
          v-else-if="item.type === 'transfer'"
          v-model="dataForm[item.prop]"
          :titles="[item.title1, item.title2]"
          filterable
          filter-placeholder="请输入搜索内容"
          :data="data"
        />

        <el-input
          v-else-if="item.type === 'textarea'"
          v-model="dataForm[item.prop]"
          :placeholder="item.placeholder"
          :autosize="{ minRows: 1, maxRows: 50 }"
        />
        <cn-region-picker
          v-else-if="item.type === 'pickCity'"
          v-model="dataForm[item.prop]"
          :placeholder="item.placeholder"
        />

        <el-input
          v-else-if="item.type === 'password'"
          v-model="dataForm[item.prop]"
          :placeholder="item.placeholder"
          show-password
          readonly
          @focus="addFocus"
        />
        <el-input
          v-else-if="item.type === 'percent'"
          v-model="dataForm[item.prop]"
          :placeholder="item.placeholder"
          type="number"
        >%</el-input>
        <el-input
          v-else-if="item.type === 'number'"
          v-model="dataForm[item.prop]"
          :placeholder="item.placeholder"
          type="number"
        />
        <el-input
          v-else-if="item.type === 'query'"
          v-model="dataForm[item.prop]"
          :placeholder="item.placeholder"
          :disabled="item.disabled"
          @blur="queryData"
        />
        <STree
          v-else-if="item.type === 'tree'"
          v-model="dataForm[item.prop]"
          :data="item.option.data"
        />

        <el-tree
          v-else-if="item.type === 'unTree'"
          :data="item.option.data"
          :props="item.defaultProps"
          style="width: 200px; margin-left: 100px; margin-top: 10px"
        />

        <SCity
          v-else-if="item.type === 'city'"
          v-model="dataForm[item.prop]"
        />

        <el-image
          v-else-if="item.type === 'image'"
          :style="{marginLeft: isShowBtn?'100px':'20px',width: '100px',height: '100px'}"
          :src="item.imageSrc"
          fit="fill"
        />

        <el-cascader
          v-else-if="item.type === 'cascaderCity'"
          :ref="item.ref"
          v-model="dataForm[item.prop]"
          :options="item.options"
          :placeholder="item.placeholder"
          :props="item.props"
        />

        <div
          v-else-if="item.type === 'div'"
          class="div-break"
          :style="item.style ? item.style : 'margin-left: 20px; width: 350px'"
        >
          {{ dataForm[item.prop] || "--" }}<span v-show="dataForm[item.prop]">{{ item.unit }}</span>
        </div>
        <div
          v-else-if="item.type === 'divCascader'"
          class="div-break"
          :style="item.style ? item.style : 'margin-left: 20px; width: 350px'"
        >
          <el-cascader v-if="dataForm[item.prop] && dataForm[item.prop].length>0" ref="three" v-model="dataForm[item.prop]" :options="item.data" placeholder="" :props="{ checkStrictly: true }" disabled />
          <span v-else>--</span>
        </div>

        <el-input
          v-else
          v-model="dataForm[item.prop]"
          :placeholder="item.placeholder"
          :disabled="item.disabled"
        />
      </el-form-item>
    </el-form>
    <div v-if="isShowBtn" class="btns">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SForm',
  props: {
    inline: {
      type: Boolean,
      default() {
        return true
      }
    },
    formStyle: {
      type: String
    },
    url: {
      type: String
    },
    imageSrc: {
      type: String
    },
    dataForm: {
      type: Object,
      default: () => {}
    },
    method: {
      type: String,
      default() {
        return 'put'
      }
    },
    labelWidth: {
      type: String,
      default() {
        return '80px'
      }
    },
    labelPosition: {
      type: String,
      default() {
        return 'right'
      }
    },
    fields: {
      type: Array,
      default() {
        return []
      }
    },
    isShowBtn: {
      type: Boolean,
      default() {
        return true
      }
    },
    before: {
      type: Function
    },
    handle: {
      type: Function
    },
    itemStyle: {
      type: String,
      default() {
        return 'display:block;'
      }
    }
  },
  data() {
    return {
      rules: {},
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  computed: {},
  watch: {},
  created: function() {
    const { fields } = this
    for (let i = 0; i < fields.length; i++) {
      const field = fields[i]
      // 设置默认选中项
      if (field.type == 'select') {
        this.$set(this.dataForm, field.prop, field.defaultValue)
      }
      if (field.rules && field.rules.length > 0) {
        this.rules[field.prop] = field.rules
      }
    }
  },
  methods: {
    save() {
      const o = this
      const { url, method, before, handle } = this
      const dataForm = this.dataForm
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let data = dataForm
          if (before) data = before(dataForm)
          if (data == false) {
            return false
          }
          if (url) {
            this.$store.dispatch('form/handle', {
              url: url,
              data: data,
              method: method,
              callback: function(resp) {
                handle(resp, o)
              }
            })
          } else {
            if (handle) handle(data, o)
          }
        } else {
          return false
        }
      })
    },
    queryData() {
      this.$emit('queryInputData')
    },
    cancel() {
      this.$router.go(-1)
    },
    addFocus(e) {
      e.target.removeAttribute('readonly')
    }
  }
}
</script>

<style scoped lang="less">
@import "./index.less";
</style>



// WEBPACK FOOTER //
// src/components/SForm/index.vue